import qs from 'qs'
import { type InconsistenciesType } from 'types/services/Inconsistencies'
import api from './api'

interface ParamsInconsistence {
  nis?: string
  cpf?: string
  codfamiliar?: string
}
export const getInconsistencies = async (params: ParamsInconsistence) => {
  try {
    const response = await api.get<InconsistenciesType>('inconsistencies', {
      params: {
        ...(Boolean(params?.nis) && { nis: params?.nis }),
        ...(Boolean(params?.cpf) && { cpf: params?.cpf }),
        ...(Boolean(params?.codfamiliar) && {
          codfamiliar: params?.codfamiliar,
        }),
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      },
    })

    return response?.data
  } catch (err) {
    return await Promise.reject(err)
  }
}
